// extracted by mini-css-extract-plugin
export default {"entry-block":"EntryBlock--entry-block--tFaE4","entryBlock":"EntryBlock--entry-block--tFaE4"};